import {ElementRef} from '@angular/core';

export abstract class HtmlHelper {

  public static checkValidity(fieldValue, fieldElement: ElementRef) {
    if (!fieldValue || !fieldValue.length) {
      if (fieldElement.nativeElement) {
        fieldElement.nativeElement.reportValidity();
        fieldElement.nativeElement.focus();
      }
      return false;
    }

    return true;
  }

  public static checkMobile(windowWidth) {
    let isMobile = false;
    (windowWidth <= 1024) ? isMobile = true : isMobile = false;
    return isMobile;
  }

  public static checkTablet(windowWidth) {
    let isTablet = false;
    (windowWidth >= 768) ? isTablet = true : isTablet = false;
    return isTablet;
  }

  public static replaceString(string, search, replacement) {
    let result = '';
    if (string) {
      const arr = string.split(search);
      result = arr.slice(0, -1).join(replacement) + arr.slice(-1);
    }
    return result;
  }

  public static isCloseToRight = (windowWidth, x, width) =>
    windowWidth > 420 ? x > windowWidth ||
      x + width / 2 > windowWidth : x > windowWidth ||
      x * 1.25 > windowWidth

  public static isCloseToLeft = (windowWidth, x) =>
    windowWidth > 420 ? x < windowWidth * 0.2 :
      windowWidth < 330 ? x < 20 : false

  public static checkForEnter = (event: KeyboardEvent): boolean => (event && event.keyCode === 13);

}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/html-helper.ts